const KEY = "blogic:returnTo";

interface StoredReturnTo {
  path: string;
  userId: string;
}

export function saveReturnTo(path: string, userId: string) {
  if (!path || path.startsWith("/login")) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, userId }));
  } catch {
    /* ignore storage failures */
  }
}

export function clearReturnTo() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore storage failures */
  }
}

/**
 * Reads and consumes the stored return path. Returns it only when it belongs
 * to the user now signing in — a different account falls back to the dashboard.
 */
export function takeReturnTo(userId: string): string | null {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    const stored = JSON.parse(raw) as StoredReturnTo;
    return stored.userId === userId ? stored.path : null;
  } catch {
    return null;
  }
}
